import { createLazyComponent, LazyModule } from 'owa-bundling';
export { getCategoryMenuPropertiesForCommandBar, getCategoryMenuPropertiesForContextMenu, } from './utils/getCategoryMenuProperties';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: MailListCategoryHeader */ './lazyIndex');
});
export var MailListCategoryHeaderSecondRowContent = createLazyComponent(lazyModule, function (m) { return m.MailListCategoryHeaderSecondRowContent; });
//# sourceMappingURL=index.js.map